type FormPageProps = {
  component: JSX.Element;
  title: string;
  subtitle?: string;
};

export const FormPage = ({ component, title, subtitle }: FormPageProps) => (
  <div className="flex justify-center">
    <div className="text-center w-96">
      <h2>{title}</h2>
      <div className="mb-4 mt-14 lg:mt-20 xl:mt-32">{subtitle}</div>
      {component}
    </div>
  </div>
);
